import { Title } from '@/components/common'
import { Box } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { ModalAddressForm } from '../accounts'

type Props = { listCities: City[] | undefined }

export const ButtonAddAddress = ({ listCities }: Props) => {
  const [isHide, setHide] = useState(true)
  const t = useTranslations()
  return (
    <Box>
      <Button variant="contained" type="button" onClick={() => setHide(false)}>
        {t('Add new address')}
      </Button>
      <Dialog open={!isHide} onClose={() => setHide(true)}>
        <DialogTitle id="alert-dialog-title">
          <Title variants="h3" iconPosition="start" className="font-bold">
            {t('Edit Address')}
          </Title>
        </DialogTitle>

        <ModalAddressForm type={'add'} onCancel={() => setHide(false)} isModal={true} />
      </Dialog>
    </Box>
  )
}
